import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import React from 'react';
import { observer } from 'mobx-react';

const fadeInLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: auto;
  animation: ${fadeInLeft} 0.8s cubic-bezier(0.4, 0, 0.2, 1) 0.3s both;
`;

const Subtitle = styled.p`
  font-weight: 400;
  color: rgba(255, 255, 255, 0.9);
  max-width: 400px;
  font-size: 16px;
  line-height: 1.6;
  text-shadow: 0 2px 12px rgba(0, 0, 0, 0.4);

  @media (min-width: 600px) {
    font-size: calc(1rem + 0.4vw);
  }
`;

const Logo = styled.img`
  width: 180px;
  margin-bottom: 16px;
  filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.3));
  transition: transform 0.3s ease;
  
  &:hover {
    transform: scale(1.02);
  }
`;

export type AuthOverlayLeftProps = {
  text: string;
};

export const AuthOverlayLeft: React.FC<AuthOverlayLeftProps> = observer(({ text }) => {
  return (
    <Container>
      <Logo src={require('../../../Assets/Images/kinastic-logo.png')} alt="logo" />
      <Subtitle className="shadow-text" dangerouslySetInnerHTML={{ __html: text?.replace(/\n/g, '<br />') }} />
    </Container>
  );
});
